import loadingReducer from "../connected-components/loader/reducer";
import themeReducer from "../theme/reducer";
import authReducer from "../screens/auth/login/reducer";
import modalReducer from "../connected-components/modal/reducer";
import qaReducer from "../screens/content/qa/reducer";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: loadingReducer,
  theme: themeReducer,
  auth: authReducer,
  modal: modalReducer,
  qa: qaReducer,
};
